import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-

// Defined in general.js
/* global isLoggedIn toast getFavList toggleSignInOverlay tryToConvertMyGPIdsToLocalStorage  */

import SelectChallenge from './SelectChallenge';
import { LoadingEllipsis } from '../common/LoadingEllipsis';

let AddSearchToChallengeLink = ({ donorGivingPages, searchURL }) => {
    const [challengesToDisplay, setChallengesToDisplay] = React.useState([]);
    const [isLoading, setLoading] = React.useState(false);

    function saveSearchToChallenge() {
        $.when(getFavList('myGPs')).then(function (donorChallenges) {
            if (!isLoggedIn()) {
                promptSignin(donorChallenges);
            } else {
                selectChallenge(donorChallenges);
            }
        });
    }

    function promptSignin(donorChallenges) {
        // Register a handler to complete adding after signin
        // This will only work if the user signs in with a PW on the same page.
        $(window).one('signinTriggered', () => selectChallenge(donorChallenges));
        toggleSignInOverlay(null, true);
    }

    function selectChallenge(donorChallenges) {
        if (donorChallenges.length === 1) {
            doSaveSearchToChallenge(donorChallenges[0].id);
        } else {
            setChallengesToDisplay(donorChallenges);
        }
    }

    function doSaveSearchToChallenge(challengeId) {
        setChallengesToDisplay([]);
        setLoading(true);

        $.ajax({
            url: secureBaseURL + 'donors/saveSearchToChallenge.html',
            dataType: 'json',
            method: 'POST',
            data: {
                id: challengeId,
                backfillURL: searchURL,
                action: 'setBackfill',
                projectType: 'custom',
            },
            // withCredentials is necessary to pass cookies since this is a cross-origin request
            xhrFields: { withCredentials: true },
        }).always(saveSearchToChallengeStatus);
    }

    function saveSearchToChallengeStatus({ responseText: status }) {
        setLoading(false);

        if (status === 'success') {
            toast('Success!');
        } else if (status === 'signinRequired') {
            toast('Please sign into your account to use this feature.');
        } else if (status === 'noChallenge') {
            toast('The giving page could not be found.');
        } else {
            toast('An unrecognized error occurred.');
        }
    }

    function saveSearch(event) {
        if (donorGivingPages.length > 0) {
            // This is a hack since we're incorrectly returning zero GPs sometimes on the search page.
            tryToConvertMyGPIdsToLocalStorage({ favIds: { myGPs: donorGivingPages } });
        }
        saveSearchToChallenge();
        event.preventDefault();
    }

    if (donorGivingPages.length === 0) {
        return null;
    }

    if (isLoading) {
        return <LoadingEllipsis />;
    }

    // Maybe some of the code for loading and selecting the challenges could be unified with AddToChallengeWidget
    return (
        <div className="followOptions">
            <span className="saveSearchToChallengeLink">
                <button className="link-button" onClick={saveSearch}>
                        Use this search for my Giving Page
                </button>
            </span>

            <div style={{ position: 'relative' }}>
                <SelectChallenge challenges={challengesToDisplay} updateChallenge={doSaveSearchToChallenge} />
            </div>
        </div>
    );
};
AddSearchToChallengeLink.propTypes = {
    donorGivingPages: PropTypes.array.isRequired,
    searchURL: PropTypes.string.isRequired,
};
AddSearchToChallengeLink = React.memo(AddSearchToChallengeLink);
export default AddSearchToChallengeLink;
